import { render, staticRenderFns } from "./TitleForm.vue?vue&type=template&id=123afaef&scoped=true&"
import script from "./TitleForm.vue?vue&type=script&lang=js&"
export * from "./TitleForm.vue?vue&type=script&lang=js&"
import style0 from "./TitleForm.vue?vue&type=style&index=0&id=123afaef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123afaef",
  null
  
)

export default component.exports